module.exports = __webpack_public_path__ + "assets/page2Slogan.f39fbb22.png";